import React from 'react'

export default function PageHeader() {
  return (
    <div className="page-head">
      <div className="page-title-row">
        <h1>Dashboard</h1>
        <span className="pill pill-ok"><span className="dot" />All systems synced</span>
        <span style={{ fontFamily: 'var(--f-mono)', fontSize: '11.5px', color: 'var(--ink-3)' }}>
          Last sync <b style={{ color: 'var(--ink-1)', fontWeight: 550 }}>2 min ago</b>
        </span>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8, alignItems: 'center' }}>
          <button className="dbtn dbtn-ghost">View changelog</button>
          <button className="dbtn dbtn-outline">Sync now</button>
          <button className="dbtn dbtn-primary">+ New project</button>
        </div>
      </div>
    </div>
  )
}
